<template>
    <div ref="loader" class="mt-2">
        <b-container class="container-lg">
            <b-row class="pb-2">
                <b-col class="text-start">
                    <h5><i class="fa-solid fa-gauge-high"></i> {{ $t('Dashboard') }}</h5>
                </b-col>
                <b-col class="text-end">
                </b-col>
            </b-row>
            <b-card class="mb-2 border-bottom-1 rounded-bottom-1">
                <div class="row">
                    <b-button-group class="w-100">
                        <button class="w-100 btn btn-light"
                                type="button"
                                @click="pushTo('dashboardsIndex')">
                            <i class="fa-solid fa-layer-group"></i>
                            {{ $t('Overview') }}
                        </button>
                        <!--<button type="button"
                                class="w-50 btn btn-light"
                                @click="pushTo('dashboardsStatuspagegroups')">
                          <i class="fa-solid fa-layer-group"></i>
                          {{ $t('Slas') }}
                        </button>-->

                    </b-button-group>
                </div>
                <div class="row">
                    <b-button-group class="w-100">
                        <button class="w-50 btn btn-light"
                                type="button"
                                @click="pushTo('dashboardsAlerts')">
                            <i class="fa-solid fa-bell"></i>
                            {{ $t('Alerts') }}
                        </button>
                        <button class="w-50 btn btn-primary"
                                type="button"
                                @click="pushTo('dashboardsTacticals')">
                            <i class="fa-solid fa-chart-area"></i>
                            {{ $t('Tacticals') }}
                        </button>

                    </b-button-group>
                </div>
                <div class="row">
                    <b-button-group class="w-100">
                        <button class="w-50 btn btn-light"
                                type="button"
                                @click="pushTo('dashboardsStatuspages')">
                            <i class="fa-solid fa-info-circle"></i>
                            {{ $t('Statuspages') }}
                        </button>
                        <button class="w-50 btn btn-light"
                                type="button"
                                @click="pushTo('dashboardsStatuspagegroups')">
                            <i class="fa-solid fa-layer-group"></i>
                            {{ $t('Statuspage groups') }}
                        </button>
                    </b-button-group>
                </div>
            </b-card>
            <div v-if="ready && !tacticalsExits">
                <b-card>
                    <b-row class="pb-2">
                        <b-col class=" text-center">
                            <h5>
                                {{ $t('No tactical overviews in oitc server dashboard') }}
                            </h5>
                        </b-col>
                    </b-row>
                </b-card>
            </div>
            <div v-if="ready && tacticalsExits">
                <template v-if="tacticalHostWidgets.length === 0">
                    <b-row class="pb-2">
                        <b-col class="text-center">
                            <h5>{{ $t('No tactical overviews for hosts in oitc-server dashboard') }}</h5>
                        </b-col>
                    </b-row>
                </template>
                <template v-if="tacticalHostWidgets.length > 0">
                    <b-row class="pb-2">
                        <b-col class="text-center">
                            <h5>{{ $t('Tactical overviews for hosts') }}</h5>
                        </b-col>
                    </b-row>
                    <b-card-group deck>
                        <template v-for="hostwidget in tacticalHostWidgets" v-bind:key="hostwidget.id"
                                  class="d-inline mb-2">
                            <tactical-host-widget :theme="theme" :title="hostwidget.title" :widget_id="hostwidget.id"/>
                        </template>
                    </b-card-group>
                </template>
                <template v-if="tacticalServiceWidgets.length === 0">
                    <b-row class="pb-2">
                        <b-col class="text-center">
                            <h5>{{ $t('No tactical overviews for services in oitc-server dashboard') }}</h5>
                        </b-col>
                    </b-row>
                </template>
                <template v-if="tacticalServiceWidgets.length > 0">
                    <b-row class="pb-2">
                        <b-col class="text-center">
                            <h5> {{ $t('Tactical overviews for services') }}</h5>
                        </b-col>
                    </b-row>
                    <b-card-group deck>
                        <template v-for="servicewidget in tacticalServiceWidgets" v-bind:key="servicewidget.id"
                                  class="mb-2">
                            <tactical-service-widget :theme="theme" :title="servicewidget.title"
                                                     :widget_id="servicewidget.id"/>
                        </template>

                    </b-card-group>
                </template>
            </div>

        </b-container>
    </div>
</template>
<script>
import TacticalHostWidget from "./dashboard/TacticalHostWidget.vue";
import TacticalServiceWidget from "./dashboard/TacticalServiceWidget.vue";
import { BRow } from 'bootstrap-vue-next';

export default {
    name: "DashboardsTacticals",
    components: {
        BRow,
        TacticalHostWidget, TacticalServiceWidget
    },
    data() {
        return {
            ready: false,
            tacticalHostWidgets: [],
            tacticalServiceWidgets: [],
            theme: 'light'
        }
    },
    async mounted() {
        await this.getWidgets();
        this.ready = true;

    },
    methods: {
        pushTo: function(name) {
            this.$router.push({name: name});
        },
        async getWidgets() {
            axios.post('/dashboards/tacticalWidgets.json').then(result => {
                this.tacticalHostWidgets = result.data.tacticalHoststatusOverviews || [];
                this.tacticalServiceWidgets = result.data.tacticalServicestatusOverviews || [];
            }).catch(error => {
                console.log(error)
            });
        }
    },
    computed: {
        tacticalsExits() {
            return this.tacticalHostWidgets.length > 0 || this.tacticalServiceWidgets.length > 0;
        }
    }
}
</script>


<style scoped>

</style>
